import { createRequest, getProxyHeadersPlugin } from '@direct-frontend/modules-request';
import { authorizePlugin } from './plugins/authorizePlugin';
import { apiRequestCommon } from './apiRequestCommon';
import { getCSRFPlugin } from './plugins';

// Для работы с FormData важно отсутствие header 'content-type' — его браузер сам выставит
export const apiFormDataRequest = createRequest({
    ...apiRequestCommon,
    timeout: 600_000, // 10 минут
    headers: {
        accept: 'application/json',
    },
    jsonContentTypeHeaders: ['multipart/form-data'],
    plugins: [
        getProxyHeadersPlugin(['cookie', 'user-agent', 'accept-language', 'testname', 'testRunId']),
        getCSRFPlugin(),
        authorizePlugin(),
    ],
});
